import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/support/faq/page.tsx");
